import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Tooltip from '../UniformComponents/Tooltip'

const DebugControl = observer((props) => {
    const { store } = props
    const { showDebug, toggleDebug } = store

    const [showAdminBox, setShowAdminBox] = useState(false)

    useEffect(() => (
        () => {
            store.showDebug = false
        }
    ), [])

    if (!store.isExploriAdmin()) return null

    const text = i18n.t(`${showDebug ? 'adminBox.hide' : 'adminBox.show'}`)
    const className = showDebug ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'

    return (
        <div
            style={{ flex: 1, cursor: 'pointer', display: 'flex', justifyContent: 'end', minHeight: 20 }}
            onClick={() => setShowAdminBox(!showAdminBox)}
        >
            {showAdminBox && (
                <Tooltip
                    text={text}
                    direction="left"
                    isNew
                >
                    <i
                        className={className}
                        onClick={toggleDebug}
                        style={{ fontSize: '16px' }}
                    />
                </Tooltip>
            )}
        </div>
    )
})

export default DebugControl
